export interface SlackConfig {
  url: string;
}

export interface EmailConfig {
  email: string;
}

interface S3Config {}

export interface WebhookConfig {
  url: string;
}

export type ActionConfig = SlackConfig | EmailConfig | S3Config | WebhookConfig;

export interface ActionBody {
  config: ActionConfig;
  channel: ActionChannel;
  name: string;
  policy_slugs: string[];
}

interface ActionBase extends ActionBody {
  is_enabled: boolean;
}

export interface Action extends ActionBase {
  id?: number;
}

export interface ActionResponse extends ActionBase {
  id: number;
}

export interface ActionTestResponse {
  success: boolean;
}

export enum ActionChannel {
  // Keep up to date with Channel from server/semgrep_app/saas/notifications/base
  SlackWebhook = "slack_webhook",
  Email = "email",
  S3 = "s3",
  Webhook = "webhook",
}

export const WebhookActionChannels = [
  ActionChannel.Webhook,
  ActionChannel.SlackWebhook,
];
